import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { Report } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';

/**
 * Service to get reports and their states
 */
@Injectable()
export class ReportService {
    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Get all reports by identityOrganizationId
     */
    public getIndex(identityOrganizationIds: string): Observable<Report[]> {
        // Make the http request
        let apiUrl: string = `${this.http.configService.getApiBaseUrl()}/reports/`;
        apiUrl += this.http.getQueryParameters(null, [`identityOrganizationIds=${identityOrganizationIds}`]);

        return this.http.get(apiUrl)
            .pipe(map((response: IJsonApiResponse) => {
                const reports: Report[] = [];
                const bodyData: any = response.data || [];
                for (const report of bodyData) {
                    reports.push((new Report()).deserialize(report));
                }

                return reports;
            }));
    }

    /**
     * Run the given team report
     *
     * @param {string} reportId
     * @param {string[]} params
     * @returns {Observable<Report[]>}
     */
    public downloadTeamReport(reportId: string, params: string[]): void {
        // Make the http request
        let apiUrl: string = `${this.http.configService.getApiBaseUrl()}/reports/${reportId}/download`;
        apiUrl += this.http.getQueryParameters(null, params);

        location.href = apiUrl;
    }

    /**
     * Run the given report
     *
     * @param {string} reportId
     * @param {string[]} params
     * @returns {Observable<Report[]>}
     */
    public emailReport(reportId: string, params: string[]): Observable<boolean> {
        // Make the http request
        let apiUrl: string = `${this.http.configService.getApiBaseUrl()}/reports/${reportId}/email`;
        apiUrl += this.http.getQueryParameters(null, params);

        return this.http.post(apiUrl, null).pipe(map(() => true));
    }
}
